// extracted by mini-css-extract-plugin
export default {"banner":"offlineBanner_banner__bOWLP","icon":"offlineBanner_icon__Y+JJy","text":"offlineBanner_text__QBOjR"};